import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from '@/auth/auth.guard';
import { environment } from '@/../environments/environment';
import { IAppConfig } from '@/shared/models';

const routeTracing = (environment as IAppConfig).routeTracing || false;

// Possible values for sameUrlNavigation ==> 'reload' or 'ignore'
const sameUrlNavigation = 'ignore';

const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('@/layout/layout.module').then(m => m.LayoutModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        loadChildren: () => import('@/auth/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'register',
        loadChildren: () => import('@/auth/register/register.module').then(m => m.RegisterModule)
    },
    // { path: '**', redirectTo: 'not-found' },
    {
        // Reset Password --> Sends a mail to the user with a link to change the password
        // The link sent to the user is https://admin.teamstreamz.com/ng/change_passwords/?token=ABCD
        path: 'reset_password',
        loadChildren: () =>
            import('@/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
    },
    {
        // Change Password --> User clicks the email link to actually change the password!
        path: 'change_passwords',
        loadChildren: () =>
            import('@/auth/change-password/change-password.module').then(
                m => m.ChangePasswordModule
            )
    },
    { path: '**', redirectTo: 'login' } // otherwise redirect to login
];

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, {
            enableTracing: routeTracing,
            onSameUrlNavigation: sameUrlNavigation,
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 60]
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
